import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux'
import endpoints, { getBackendUrl } from '../../endpoints';
import axios from 'axios';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/SaveRounded';
import withAlert from '../../hoc/withAlerts'
import { setUserdata } from '../../redux/authSlice'
import { setHeader } from '../../redux/headerSlice'

function Me(props) {
    const personalErrorStruct = {
        firstname: {
            state: false,
            text: ''
        },
        lastname: {
            state: false,
            text: ''
        },
    }

    const token = useSelector((state) => state.auth.token)
    const firstName = useSelector((state) => state.auth.userdata.firstname)
    const lastName = useSelector((state) => state.auth.userdata.lastname)
    const [personalError, setPersonalError] = useState(personalErrorStruct)

    const dispatch = useDispatch()

    const [personalData, setPersonalData] = useState({
        firstname: firstName,
        lastname: lastName,
    })

    useEffect(() => {
        dispatch(setHeader({
            title: 'Profile'
        }))
    }, []);

    const updatePersonalData = async () => {
        let uri = getBackendUrl(endpoints.auth, token)

        try {
            let res = await axios.put(uri, personalData)
            showAlertSuccess('Profile updated successfully!')
            dispatch(setUserdata(res.data.user))

            setPersonalError(personalErrorStruct) // clear personal Error
        } catch (e) {
            if ((e.response) && (e.response.data) && (e.response.data.status === 'invalidate')) {
                let newVal = JSON.parse(JSON.stringify(personalErrorStruct))

                for (const [key, value] of Object.entries(e.response.data.details)) {
                    let fields = Object.keys(personalErrorStruct)
                    fields.forEach(function (field) {
                        if (key.indexOf(field) !== -1) {
                            newVal[field].state = true
                            newVal[field].text = value
                        }
                    })
                }

                if ((JSON.stringify(newVal) != JSON.stringify(personalErrorStruct))) {
                    setPersonalError(newVal)
                }
            }
            showAlertError('Unknown Error - update profile')
        }
    }

    const changePersonalDataHandler = (e) => {
        personalData[e.target.name] = e.target.value
        setPersonalData(personalData)
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Paper sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
            <Stack direction="row" spacing={2} sx={{p: 3, pb:5}}>
                <TextField
                    error={personalError.firstname.state ?? ''}
                    helperText={personalError.firstname.text}
                    name="firstname"
                    onChange={changePersonalDataHandler}
                    defaultValue={personalData.firstname ?? ''}
                    label="First name" 
                    variant="standard"
                />
                <TextField
                    error={personalError.lastname.state ?? ''}
                    helperText={personalError.lastname.text}
                    name="lastname"
                    onChange={changePersonalDataHandler}
                    defaultValue={personalData.lastname ?? ''}
                    label="Last name" 
                    variant="standard"
                />
                <FormControl variant="standard" sx={{ paddingTop:1.5 }}>
                    <Button 
                        onClick={updatePersonalData} 
                        variant="contained"
                        color="primary"
                        startIcon={<SaveIcon />}
                        sx={{width:'auto'}}
                    >
                        Save
                    </Button>
                </FormControl>
            </Stack>
        </Paper>
    );
}

export default withAlert(Me)